// extracted by extract-css-chunks-webpack-plugin
module.exports = {"left_box":"left_box-7AdOw5gz","dbox":"dbox-1RcQuxXt"};